import actionTypes from 'dashboard/actions/net-sales/action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NET_SALES_SUMMARY_REQUEST:
    case actionTypes.FETCH_NET_SALES_SUMMARY_FAILURE:
    case actionTypes.FETCH_NET_SALES_SUMMARY_SUCCESS:
    case actionTypes.FETCH_NET_SALES_DETAILS_REQUEST:
    case actionTypes.FETCH_NET_SALES_DETAILS_FAILURE:
    case actionTypes.FETCH_NET_SALES_DETAILS_SUCCESS: {
      return action.isLoading;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/net-sales/loading-status.js